import styled from 'styled-components';
import Colors from 'library/constants/colors';
import { StyledInput, Icon } from 'library/components/form/input/styles';
import { ButtonSecondaryStyles } from 'library/styles/button';

// eslint-disable-next-line import/prefer-default-export
export const FieldContainer = styled.div`
  display: flex;
  justify-content: space-between;
  z-index: 2;
  margin-top: 10px;
  color: ${Colors.violet};
  align-items: baseline;

  ${StyledInput} {
    &:read-only {
      opacity: 0.5;
      cursor: not-allowed;
      padding-right: 15px;
      background-color: ${Colors.shade05};
    }
  }

  ${Icon} {
    opacity: ${({ isReadOnly }) => (isReadOnly ? 0.3 : 'inherit')} !important;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 40px;
`;

export const PlusIcon = styled.i`
  font-size: 28px;
  color: ${Colors.violet};
`;

export const DeleteIcon = styled.i`
  font-size: 28px;
  font-weight: bold;
  color: ${Colors.redLight};
  cursor: pointer;
  opacity: 0.7;
  display: ${({ disabled }) => (disabled ? 'none' : 'inherit')};
  z-index: 2;

  :hover {
    opacity: 1;
  }
`;

export const AddUrlBtn = styled.button`

  ${ButtonSecondaryStyles};
  max-width: 70px;
  margin-left: 10px;


  &:disabled {
    color: ${Colors.shade08} !important;

    i {
      color: ${Colors.shade08} !important;
    }
  }

`;
